import HeaderMenuDivide from "../../../assets/img/top_menu_dividers_shine_effect.png";
import HeaderMenuDivideRev from "../../../assets/img/top_menu_dividers_shine_effect-rev.png";
import React, {memo} from "react";
import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles({
    content: {
        display: 'flex'
    },
    text: {
        margin: '0.3vw 1.1vw'
    }
})

const DropDownItem = ({onClick, label}) => {

    const classes = useStyles()

    return (<div className="dropdown-line"
                 onClick={onClick}>
        <div className={classes.content}>
            <img alt={""} className="dropdown-left-line" src={HeaderMenuDivide}/>
            <div className={classes.text}>{label}</div>
        </div>
        <img alt={""} className="dropdown-bottom-line" src={HeaderMenuDivideRev}/>
    </div>);
}

export default memo(DropDownItem)